<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MDKlb0/e9781429996211_cover.jpg?1718046199169" alt="This image is the cover for the book Alice Invents a Little Game and Alice Always Wins"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alice Invents a Little Game and Alice Always Wins
      </h1>
      <p class="bookDescription body article font2">
        <p>In this first play from the award-winning memoirist and poet Nick Flynn, four strangers meet during a blackout on a New York City sidewalk. Gideon finds himself locked out of his apartment, stranded on the street with nothing but a television and the company of three individuals, each mysterious in their own way: the specter-like Alice, ringleader of the neighborhood; Esra, a fifteen-year-old girl whose mother is MIA—again; and Ivan, a stranded businessman trying to make his way home. As Gideon makes futile attempts to break into an apartment that may or may not be his, an unsettling connection between Ivan and Esra develops while Alice and Gideon look on helplessly. Unable to make sense of their predicament, let alone alter it, the four float aimlessly in and out of seeming reality only to find themselves more lost when the electricity finally comes back on. <br/><br/>Once again exploring the tenuous membrane that separates comfortable, everyday existence from the desperate margins of society, Flynn portrays an urban dystopia disturbingly similar to our own world while poignantly tapping into the loneliness and peril of city life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nick Flynn
      </h2>
      
      <p class="authorDescription body article"><P><B>NICK FLYNN</B>'s work—which includes <I>Another Bullshit Night in Suck City</I>, winner of the PEN/Martha Albrand Award for Memoir, and the poetry collections <I>Blind Huber </I>and <I>Some Ether—</I>has been translated into thirteen languages.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?066aa6ef